<template>
	<b-row>
		<b-col cols="12" lg="4" offset-lg="2" class="mb-4 mb-lg-0">
			<slot></slot>
		</b-col>
		<b-col cols="12" lg="4">
			<img src="" alt="">
		</b-col>
	</b-row>
</template>

<script>
	//const axios = require('axios');
	export default {
		props: {},
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	img {
		width: 100%;
	}
</style>